import React, {useContext, useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import Spinner from '../../../Spinner';
import {Context} from '../../../../Helpers/Auth';
import NotFound from '../../../NotFound';
import TablePagination from '../../../TablePagination';
import {getStatusOrcamentos} from '../../../../pages/requests';

function StatusOrcamento() {
    const {t} = useTranslation();

    let lang;
    switch (localStorage.getItem('i18nextLng')) {
        case 'pt':
            lang = 'POR';
            break;
        case 'fr':
            lang = 'FRA';
            break;
        case 'en':
            lang = 'ENG';
            break;
        case 'es':
            lang = 'ES'; 
            break;
    }

    const [loading, setLoading] = useState(true);

    const {isCard, openCards} = useContext(Context);

    const [isMobile, setIsMobile] = useState(false);

    const [status, setStatus] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const [totalLinhas, setTotalLinhas] = useState(0);
    const [semDados, setSemDados] = useState(false);

    const ITEMS_PER_PAGE = 15;

    const handleResize = () => {
        setIsMobile(window.innerWidth < 800);
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        setLoading(false);
        var promises = [];
        const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
        const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;
        promises.push(
            getStatusOrcamentos(lang, indexOfFirstItem, indexOfLastItem).then(res => {
                if (res.data.success) {
                    setStatus(res.data.statusOrcamento);
                    setTotalLinhas(res.data.totalLinhas);
                }
            }),
        );

        Promise.all(promises).finally(() => {
            setLoading(false);
        });
    }, [currentPage]);

    return (
        <div>
            <div>
                {isMobile || isCard ? (
                    <div>
                        <div className="flex dark:bg-gray-600 rounded-t-[8px] bg-gray-100  flex-wrap items-center px-4 py-2">
                            <div className="relative  w-full max-w-full flex-grow flex-1 ">
                                <h3 className="font-semibold text-base text-gray-900 dark:text-gray-50 ">{t('statusOrcamento')}</h3>
                            </div>
                        </div>
                        {status?.map((dados, index) => (
                            <>
                                <div key={index} className={`rounded-none border border-l-0 border-r-0 border-t-0 border-neutral-200 bg-white dark:border-neutral-600 dark:bg-gray-800`}>
                                    <h2 className="mb-0" id="headingOne">
                                        <button
                                            className="group relative flex w-full font-medium items-center rounded-none border-0 bg-white px-5 py-1 text-left text-base text-neutral-800 transition [overflow-anchor:none] hover:z-[2] dark:bg-gray-800 text-primary   dark:text-white "
                                            type="button"
                                            data-te-collapse-init
                                            data-te-collapse-collapsed
                                            data-te-target={'#flush-collapseThreeLeads' + index}
                                            aria-expanded="false"
                                            aria-controls="flush-collapseThree">
                                            <div className="flex flex-row">
                                                {dados.nomeEmpresa} | {dados.quantidade} |
                                            </div>
                                            <span className="ml-auto h-5 w-5 shrink-0 rotate-[180deg] fill-[#336dec] transition-transform duration-200 ease-in-out group-[[data-te-collapse-collapsed]]:rotate-0 group-[[data-te-collapse-collapsed]]:fill-[#075baf] motion-reduce:transition-none dark:fill-blue-300 dark:group-[[data-te-collapse-collapsed]]:fill-white">
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="h-6 w-6">
                                                    <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                                                </svg>
                                            </span>
                                        </button>
                                    </h2>
                                    <div
                                        id={'flush-collapseThreeLeads' + index}
                                        className={openCards ? 'visible' : '!visible hidden'}
                                        data-te-collapse-item
                                        aria-labelledby="flush-headingThree"
                                        data-te-parent="#accordionFlushExample">
                                        <div className="px-5 py-4">
                                            <div className="text-gray-500 flex flex-row">
                                                <div className="font-medium text-gray-400 mr-2">{t('representante')}:</div> {dados.gestorCliente}
                                            </div>
                                            <div className="text-gray-500 flex flex-row">
                                                <div className="font-medium text-gray-400 mr-2">{t('quantidade')}: </div> {dados.quantidade}
                                            </div>
                                            <div className="text-gray-500 flex flex-row">
                                                <div className="font-medium text-gray-400 mr-2">{t('volume')}: </div> {dados.valor}
                                            </div>
                                            <div className="text-gray-500 flex flex-row">
                                                <div className="font-medium text-gray-400 mr-2">{t('estado')}: </div> {dados.estado}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        ))}

                        {semDados && !loading && <NotFound frase={t('semRegistos')} />}

                        {loading && (
                            <div className="flex flex-row mt-14 justify-center">
                                <>
                                    <Spinner />
                                </>
                            </div>
                        )}

                        <nav className="flex items-center justify-between ml-4 pt-4" aria-label="Table navigation">
                            <div>
                                <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                                    {t('pagina')} <span className="font-semibold text-gray-900 dark:text-white">{currentPage}</span> {t('de')}{' '}
                                    <span className="font-semibold text-gray-900 dark:text-white">{Math.ceil(totalLinhas / ITEMS_PER_PAGE)}</span>
                                </span>

                                <span className="font-semibold ml-4 text-sm text-gray-900 dark:text-white">{totalLinhas}</span>
                                <span className="ml-2 mr-2 text-sm font-normal text-gray-500 dark:text-gray-400">{t('registos')}</span>
                            </div>
                            {totalLinhas != 0 && <TablePagination total={totalLinhas} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={page => setCurrentPage(page)} />}
                        </nav>
                    </div>
                ) : (
                    <div className="relative min-h-[415px] overflow-x-auto shadow sm:rounded-[8px]">
                        <div className="flex dark:bg-gray-600  flex-wrap items-center px-4 py-2">
                            <div className="relative  w-full max-w-full flex-grow flex-1 ">
                                <h3 className="font-semibold text-base text-gray-900 dark:text-gray-50 ">{t('statusOrcamento')}</h3>
                            </div>
                        </div>
                        <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                            <thead className="text-xs text-gray-700 uppercase bg-gray-100 dark:bg-gray-800 dark:text-gray-300">
                                <tr>
                                    <th scope="col" className="px-6 py-3 w-72">
                                        {t('representante')}
                                    </th>

                                    <th scope="col" className="px-6 py-3">
                                        {t('quantidade')}
                                    </th>

                                    <th scope="col" className="px-6 py-3">
                                        {t('volume')}
                                    </th>
                                    <th scope="col" className="px-6 py-3">
                                        {t('estado')}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {status?.map(dados => {
                                    return (
                                        <tr className="odd:bg-white even:bg-gray-100 odd:dark:bg-gray-700 hover:border-2 border-b cursor-pointer dark:bg-gray-800 dark:border-gray-600 hover:border-amber-400 hover:dark:border-amber-400 ">
                                            <th scope="row" className="px-6 py-1 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                                {dados.gestorCliente}
                                            </th>

                                            <td className="px-6 py-1 w-74">{dados.quantidade}</td>

                                            <td className="px-6 py-1">{dados.valor}</td>

                                            <td className=" py-1">{dados.estado}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                        {semDados && !loading && <NotFound frase={t('semRegistos')} />}

                        {loading && (
                            <div className="flex flex-row mt-14 justify-center">
                                <>
                                    <Spinner />
                                </>
                            </div>
                        )}
                        <nav className="flex items-center justify-between ml-4 pt-4" aria-label="Table navigation">
                            <div>
                                <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                                    {t('pagina')} <span className="font-semibold text-gray-900 dark:text-white">{currentPage}</span> {t('de')}{' '}
                                    <span className="font-semibold text-gray-900 dark:text-white">{Math.ceil(totalLinhas / ITEMS_PER_PAGE)}</span>
                                </span>

                                <span className="font-semibold ml-4 text-sm text-gray-900 dark:text-white">{totalLinhas}</span>
                                <span className="ml-2 mr-2 text-sm font-normal text-gray-500 dark:text-gray-400">{t('registos')}</span>
                            </div>
                            {totalLinhas != 0 && <TablePagination total={totalLinhas} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={page => setCurrentPage(page)} />}
                        </nav>
                    </div>
                )}
            </div>
        </div>
    );
}

export default StatusOrcamento;
